<template>
    <div class="symbols__body">

        <div class="symbols__body--item"> 
            <div class="light lights__red"></div> 
            <span>Något behöver åtgärdas snarast</span>
        </div>
        <div class="symbols__body--item"> 
            <div class="light lights__yellow"></div> 
            <span>Något kan behöva ses över</span>
        </div>
        <div class="symbols__body--item"> 
            <div class="light lights__green"></div> 
            <span>Allt ser bra ut</span>
        </div>

    </div>
</template>

<script>
export default {

}
</script>